import { NavLink } from 'react-router';
import { navItems } from './navItems';

export const BottomNav = () => (
  <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-gray-200 flex">
    {navItems.filter((item) => !item.desktopOnly).map(({ to, label, Icon }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          `flex-1 flex flex-col items-center justify-center gap-1 py-2 min-h-[56px] text-[11px] font-medium transition-colors ${
            isActive ? 'text-gray-900' : 'text-gray-400 hover:text-gray-700'
          }`
        }
      >
        <Icon />
        <span className="leading-none">{label}</span>
      </NavLink>
    ))}
  </nav>
);
